export enum ApiUrls {
  login = 'auth/login',
  register = 'auth/register',
  changePassword = '/auth/update-password',
  requestResetPassword = 'auth/request-reset-password',
  resetPassword = 'auth/reset-password',
  divsion = 'division/',
}
